module.exports = __webpack_public_path__ + "static/media/Finiquitos_Liquidacion.f97b9583.svg";